// extracted by mini-css-extract-plugin
export default {"tableDistance":"NewDistanceTable_tableDistance__2TdwM","formDiv":"NewDistanceTable_formDiv__fGeA4"};